import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { useEffect } from 'react';
import './SuccessfulPage.css';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	root: {
		background: 'url(assets/images/banner/bg.png) no-repeat center',
		backgroundSize: 'cover',
		color: theme.palette.primary.contrastText,
	},
}));
const SuccessfulPage = () => {
	const classes = useStyles();
	const navigate = useNavigate();
	const redirect = () => {
		navigate('/login');
	};

	useEffect(() => {
		const timeout = setTimeout(redirect, 2000);
		return () => clearTimeout(timeout);
	}, []);

	return (
		<div className={clsx(classes.root, 'flex flex-col flex-auto shrink-0 items-center justify-center p-32')}>
			<div className="flex flex-col items-center justify-center w-full">
				<FuseAnimate animation="transition.expandIn">
					<Card className="forget-width">
						<CardContent className="flex flex-col items-center justify-center p-32">
							<img alt="logo" className="mb-2 gd text-center logo-img" src="assets/images/logos/logo.png" width={150} />
							<Typography className="mt-16 mb-32 hellloooo" variant="h6">
								<img alt="check" src="assets/images/banner/successfully-icon.png" />
							</Typography>
							<h2 className="hd-succ">Password Successfully Updated</h2>
							<p className="para-succ parasucces">Your have successfully reset your password</p>
							{/* <button id="signin-btn" type="button" onClick={redirect}></button> */}
							<div className="flex justify-center mt-32">
								<CustomButton onClick={redirect} type="submit" width={145}>
									Sign In
								</CustomButton>
							</div>
						</CardContent>
					</Card>
				</FuseAnimate>
			</div>
		</div>
	);
};
export default SuccessfulPage;
